module.exports = __webpack_public_path__ + "8d2905b8eefbe001f3b99b699daac5fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/12.jpg
// module id = 1338
// module chunks = 47